export { useFaqState } from '../../../../contact/expertise-livre/components/ExpertisePageDetails/hooks';
export { useLocalizedContent } from './useLocalizedContent';
